export const CONNECTION_PROFILE_STATUS = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
};
